import React from 'react';
import * as PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';

const LineChart = ({ chartData }) => {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  
  return (
    <Line
      data={chartData}
      options={{
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: isMobile ? 0.75 : 2,
        scales: {
          x: {
            gridLines: {
              display: true
            },
            ticks: {
              maxRotation: 45,
              minRotation: 0,
              autoSkip: true,
              maxTicksLimit: isMobile ? 8 : 15
            }
          },
          y: {
            beginAtZero: true,
            gridLines: {
              display: true
            },
            ticks: {
              precision: 0
            }
          }
        },
        plugins: {
          legend: {
            display: true,
            position: isMobile ? 'bottom' : 'top',
            labels: {
              boxWidth: 15,
              padding: isMobile ? 8 : 10,
              font: {
                size: isMobile ? 10 : 12
              }
            }
          }
        }
      }}
    />
  );
};

export default LineChart;

LineChart.propTypes = {
  chartData: PropTypes.instanceOf(Object).isRequired
};
